import { createSelector } from 'reselect'
import userTypeSelector from './userTypeSelector'
import userViewSelector from './userViewSelector'
import viewTypes from '../../../helpers/enums/views'
import userTypes from '../../../helpers/enums/userTypes'
import sessionTypes, { previewSessionTypes } from '../../../helpers/enums/sessionTypes'
import { IStore } from '../../reducers/index'

const configSelector = (state: any) => state.app.config
const skinSelector = (state: any) => state.app.skin
const sessionTypeSelector = (state: IStore) => state.app.sessionType
const splashSelector = (state: any) => state.app.isSplashComplete
const appConnected = (state: any) => state.app.isConnected
const userCanParticipate = (state: any) => state.app.canParticipate
const userInteraction = (state: IStore) => state.app.userInteracted

export default createSelector(
	userViewSelector,
	configSelector,
	skinSelector,
	userTypeSelector,
	splashSelector,
	appConnected,
	sessionTypeSelector,
	userCanParticipate,
	userInteraction,
	(viewType, config, skin, userType, isSplashComplete, isAppConnected, sessionType, canParticipate, userInteracted) => {
		let view
		if (!config._loaded) {
			view = ''
		} else if (!canParticipate) {
			view = viewTypes.SPLASH
		} else if (
			!isSplashComplete ||
			((!isAppConnected || !skin._loaded) &&
				(sessionType === sessionTypes.LIVE_SESSION || sessionType === sessionTypes.HOMEWORK)) ||
			sessionType === sessionTypes.PREVIEW ||
			viewType === viewTypes.SETTINGS
		) {
			view = viewTypes.SPLASH
		} else if (previewSessionTypes.includes(sessionType)) {
			if (!skin._loaded) {
				view = viewTypes.SPLASH
			} else {
				view = viewTypes.PREVIEW
			}
		} else if (userType === userTypes.TEACHER) {
			// For Student Paced games, we want to show the overall leaders dashboard to the teachers
			// so they see how are the students doing. For SP the viewType it's always on GAME
			// that's why we are adding that validation here
			if (viewType === viewTypes.GAME && sessionType === sessionTypes.LIVE_SESSION) {
				view = viewTypes.TEACHER_GAME
			} else if (viewType === viewTypes.WINNERS || sessionType === sessionTypes.HOMEWORK) {
				view = viewTypes.TEACHER_WINNERS
			} else {
				view = viewType
			}
		} else {
			view = viewType
		}

		return {
			view,
			userInteracted,
		}
	}
)
